module.exports = __webpack_public_path__ + "img/logo-3.4bd644d5.png";